import { render, staticRenderFns } from "./LandingPages.vue?vue&type=template&id=9dbac940&"
import script from "./LandingPages.vue?vue&type=script&lang=js&"
export * from "./LandingPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports